var exports = {
  "Nr": "PlutoniumPageLinkCard.module__card___SEs4TD",
  "Kk": "PlutoniumPageLinkCard.module__icon___SEs4TD",
  "Qq": "PlutoniumPageLinkCard.module__text___SEs4TD",
  "DD": "PlutoniumPageLinkCard.module__title___SEs4TD",
  "rf": "PlutoniumPageLinkCard.module__body___SEs4TD",
};

module.exports = exports;
